import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import axios from 'axios';
import { PuffLoader } from 'react-spinners';
import BASE_URL from '../../../../Util/config';

const JajaranDireksi = () => {
  const [newData, setNewData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    AOS.init({
      duration: 1300,
    });
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${BASE_URL}/api/structure-organization/active?order=asc`);

        if (response.status === 200) {
          // Filter data berdasarkan status aktif
          const komisarisData = response.data.data.filter((item) => item.status === true && item.approvalStatus === 'published' && item.positionTypeId === 1);

          const formattedData = komisarisData.map((item) => ({
            id: item.id,
            nama_lengkap: item.fullname_id,
            jabatan: item.positionName_id,
            // Tambahkan base URL ke filepath
            foto_profile: item.filepath ? `${BASE_URL}/${item.filepath}` : null,
            sejarah_karir: item.careerHistory_id,
            educationHistory: item.educationHistory_id,
          }));

          setNewData(formattedData);
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        console.error('Terjadi kesalahan:', error);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      {loading ? (
        <div className="loading-spinner-news">
          <PuffLoader color="#007bff" size={100} margin={2} />
        </div>
      ) : (
        <div>
          {newData.map((profile, index) => (
            <div className="col-profile d-flex mt-5" data-aos="fade-up" key={index}>
              <div className="col-6 profile-box">{profile.foto_profile && <img src={profile.foto_profile} alt={profile.nama_lengkap} />}</div>
              <div className="mx-4">
                <div className="nameDivision">
                  <h6>{profile.nama_lengkap}</h6>
                  <p>{profile.jabatan}</p>
                </div>
                <p dangerouslySetInnerHTML={{ __html: profile.educationHistory }} />
                <p dangerouslySetInnerHTML={{ __html: profile.sejarah_karir }} />
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default JajaranDireksi;
